import React, { useEffect, useState } from 'react'
import './css/signgift.css'
import general, { redux } from '../../../general';
import Dialog from '../../../lib/Dialog';
import Image from '../../../lib/Image';
import Subtitle from '../../components/Subtitle';
import SignAlert from '../gamesign/SignAlert';
import { NavLink } from '../../../lib/Navigation';
import { useLockFn, useScroll } from 'ahooks'
import useUrlState from "@ahooksjs/use-url-state";
import useActiveState from '../../../lib/useActiveState'
import $ from 'jquery'
import SelectAccount, { useSelectAccount } from '../../components/alert/SelectAccount';
import { showDownloadGameAlert } from '../../components/alert/XHModalShow';
import GameTags from '../../components/game/GameTags';

export default function SignGift(props) {

  const [tag_id, settag_id] = useState('')
  const [data, setData] = useState()
  const [init, setInit] = useState(false)
  const [visible, setVisible] = useState(false)
  const [gift, setGift] = useState()
  const [more,setMore] = useState(false)
  const [page,setPage] = useState(1)
  const [game_list, setgame_list] = useState([])
  const [load, setLoad] = useState(false)
  const [params, setParams] = useUrlState({}, {navigateMode: 'replace'});
  const [user,setUser] = useActiveState('user')

  const usePageVisibility=(onVisible,onHidden)=>{
    useEffect(()=>{
      const handlevisibilitychange =()=>{
        if(document.visibilityState == "visible"){
          onVisible && onVisible();
        } else {
          onHidden && onHidden();
        }
      }
      document.addEventListener("visibilitychange", handlevisibilitychange);
      return()=>{
        document.removeEventListener("visibilitychange",handlevisibilitychange);
      };
    },[onVisible, onHidden]);
  }

  usePageVisibility(()=>{
    urlLogin()
  },()=>{
    
  })

  useEffect(()=>{
    urlLogin()
  },[])

  const urlLogin = () => {
    if (params.userid && params.username && params.token) {
      if (window.navigator.standalone && localStorage.getItem('logout')) {
        return;
      }
      localStorage.setItem('user_id', params.userid);
      localStorage.setItem('username', params.username);
      localStorage.setItem('token', params.token);
      load_load()
    }
  }

  const load_load = useLockFn(async () => {
    await general.axios.post('/user/user/getMemberInfo')
      .finally(() => {
      })
      .then(response => {
        let {status, data} = response.data;
        if (!status.succeed) {

        } else {
          setUser({isLogin: true, ...data.member_info});
          getData()
        }
      })
      .catch(err => {
          Dialog.error(err.message);
        });
  })
  
  const getData = (loading,tag,pages) => {
    if (load){
      return
    }
    setLoad(true)
    if (loading){
      Dialog.loading()
    }
    general.axios.post('/base/signbonusV2/getSignGiftList', {
      id: props.query.id,
      tag_id:tag,
      pagination:{
        page:pages,
        count:20
      }
    }).finally(() => {
      Dialog.close()
    }).then(res => {
      const { data, status } = res.data
      if (status.succeed) {
        setLoad(false)
        setData(data)
        setInit(true)
        setgame_list(() => pages == 1 ? res.data.data.game_list : [...game_list, ...res.data.data.game_list]);
        setPage(pages)
        let {paginated} = data;
        setMore(paginated.more);
      } else {
        Dialog.error(status.error_desc)
      }
    })
  }

  useEffect(() => {
    if (props.active) {
      getData(!init,tag_id,1)
      props.setOperate(<NavLink to='/user/gift'>我的礼包</NavLink>)
    }
  }, [props.active])

  const scroll = useScroll()
  useEffect(()=>{
    if(props.active){
      if (scroll.top > 40){
        props.setTitle('签到礼包')
      }else {
        props.setTitle('')
      }
      if (scroll.top < -80) {
        getData(true,tag_id,1);
      }
      if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
        getData(true,tag_id, page + 1);
      }
    }
  },[scroll,props.active])

  const handleTag = (item) => {
    settag_id(item.id)
    getData(true,item.id,1)
  }

  const {visibleChange,selectAccountInfo,appendTopic_id} = useSelectAccount()
  const [maiyou_gameid, setmaiyou_gameid] = useState('')

  const handleRequetXHData = (xhlist) => {
    if (xhlist.length == 0){
      showDownloadGameAlert()
    }else if (xhlist.length == 1){
      sign({maiyou_gameid,trumpet_name:xhlist[0].xh_username})
    }else{
      visibleChange(true,maiyou_gameid)
    }
  }

  const handleCompletion = (xh) => {
    sign({maiyou_gameid,trumpet_name:xh.xh_username})
  }

  const sign = (item)=>{
    Dialog.loading()
    general.axios.post('/base/signbonusV2/sign', {
      topic_id: item.maiyou_gameid,
      trumpet_name:item.trumpet_name
    }).finally(()=>{
      Dialog.close()
    }).then(res => {
      const { status } = res.data
      if (status.succeed) {
        setVisible(true)
        setGift(res.data.data)
        data.play_list.map(obj=>{
          if (obj.id == item.id){
            obj.isTodaySign = true
          }
        })
        setData({...data})
      } else {
        Dialog.error(status.error_desc)
      }
    })
  }

  return (
    <div className='sign-gift'>
      {data && <div className='sign-gift-container'>
        <img src="resources/game/sign/title.png" alt="" />
        <div className="games">
          {data?.play_list.length > 0 && <div className="playing">
            <SelectAccount handleCompletion={handleCompletion} topic_id={maiyou_gameid} handleRequetXHData={handleRequetXHData}></SelectAccount>
            <div className='sign-gift-title'>我玩过的游戏</div>
            <div className="game">
              {data?.play_list.map(item => {
                return (
                  <div  className='item'>
                    <NavLink user={false} to={`/game?id=${item.game_id}`}>
                      <img src={item.game_image.thumb} height={51} alt=""/>
                    </NavLink>
                    <NavLink user={false} to={`/gamesign?id=${item.maiyou_gameid}`} className='content'>
                      <div className="name">{item.game_name}</div>
                      <div className="desc">{item.game_classify_type.trim()} · {item.nameRemark}</div>
                    </NavLink>
                    <NavLink className={"btn " + (item.isTodaySign ? 'disable' : '')} onClick={()=>{
                      if (item.isTodaySign){
                        return
                      }
                      setmaiyou_gameid(appendTopic_id(item.maiyou_gameid))
                    }}>{item.isTodaySign ? '今日已签' : '去签到'}</NavLink>
                  </div>
                )
              })}
            </div>
          </div>}
          <div className="allgame">
            <div className="sign-gift-title">全部游戏</div>
            <div className="tags">
              {data?.tag.map(item => {
                return (
                  <div key={item.id} onClick={() => handleTag(item)} className={'tag ' + (tag_id == item.id ? 'active' : '')}>
                    <div className="name">{item.tagname}</div>
                  </div>
                )
              })}
            </div>
            <div className="list">
              {game_list.map(game => {
                return (
                  <NavLink user={false} to={`gamesign?id=${game.maiyou_gameid}`} className='item'>
                    <div className="game">
                      <NavLink user={false} to={`/game?id=${game.game_id}`}>
                        <Image className="icon" src={game.game_image.thumb} />
                      </NavLink>
                      <div className="text">
                        <div className="name">{game.game_name}</div>
                        <div className="info1">
                          {game.game_classify_type.trim()}
                          <Subtitle>{game.nameRemark}</Subtitle>
                        </div>
                        <GameTags game={game}></GameTags>
                      </div>
                      <div className="btn">去签到</div>
                    </div>
                    <div className="gift">
                      <img className='icon' src="resources/game/sign/7天.png" alt="" />
                      <span className='number'>{game.sign_gift_number}</span>
                      <span className='text'>{game.sign_gift_text}</span>
                    </div>
                  </NavLink>
                )
              })}
            </div>
          </div>
        </div>
        {game_list?.length > 0 && !more ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
      </div>}
      {visible && <SignAlert gift={gift} visible={visible} action={() => setVisible(false)}></SignAlert>}
    </div>
  )
}
